// Pure catalog helpers for ReportLauncherPage (CD-5241) — kept out of the
// component so filtering/count logic is unit-testable without a DOM.

export function filterSectionsByPermission(sections: any[], hasPermission: (roleKey: string) => boolean): any[] {
  return sections
    .map((section: any) => ({
      ...section,
      cards: section.cards.filter((card: any) => !card.roleKey || hasPermission(card.roleKey)),
    }))
    .filter((section: any) => section.cards.length > 0);
}

export function filterSectionsByQuery(sections: any[], query: string): any[] {
  const q = (query || '').trim().toLowerCase();
  if (!q) return sections;
  return sections
    .map((section: any) => ({
      ...section,
      cards: section.cards.filter((card: any) =>
        `${card.title} ${card.description || ''} ${card.fmt || ''}`.toLowerCase().includes(q)
      ),
    }))
    .filter((section: any) => section.cards.length > 0);
}

export function countCards(sections: any[]): number {
  return sections.reduce((n: number, section: any) => n + section.cards.length, 0);
}
